import { axiosInstance } from "../../../Services";

// Add New Version
export const AddInventoryVersion = async (id) => {
  try {
    const res = await axiosInstance.post(
      `/rsform/inventories/version/${id}`,
      {},
      {
        headers: {
          "x-api-key": localStorage.getItem("token"),
        },
      }
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

// Get All Versions
export const GetInventoryVersions = async (id) => {
  try {
    const res = await axiosInstance.get(
      `/rsform/inventories/${id}/versions`,
      {
        headers: {
          "x-api-key": localStorage.getItem("token"),
        },
      }
    );
    return res.data?.data || [];
  } catch (err) {
    throw err;
  }
};

// Get Completed Inventory
export const GetCompletedInventory = async (id) => {
  try {
    const res = await axiosInstance.get(
      `/rsform/inventories/${id}/completed`,
      {
        headers: {
          "x-api-key": localStorage.getItem("token"),
        },
      }
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};
